import{useCallback as o,useState as u}from"react";const n=(l=!1)=>{const[e,a]=u(l),s=o(()=>{a(!0)},[]),t=o(()=>{a(!1)},[]),r=o(()=>{e?t():s()},[e,t,s]);return[e,s,t,r]};export{n as useBooleanValue};
